export default __webpack_public_path__ + "static/media/Kitchen.d0769877.jpg";